import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { LazyMotion, domAnimation } from "framer-motion";
import route from "./providers/route";
import { FaWhatsapp } from "react-icons/fa";
import { CookieConsentProvider } from "./context/CookieConsentContext";
import CookieBanner from "./components/CookieBanner";
import CookiePreferencesModal from "./components/CookiePreferencesModal";
import CookieSettingsLink from "./components/CookieSettingsLink";
import AnalyticsLoader from "./components/AnalyticsLoader";

function App() {
  let routes = useRoutes(route);

  return (
    // LazyMotion provides the animation "features" that `m.*` components
    // (as opposed to the full `motion.*` components) need to actually
    // animate. domAnimation covers fades, slides, hover/tap scale, and
    // other everyday transitions — it excludes drag gestures and layout
    // animations, which is why it's the smaller of Framer Motion's two
    // feature bundles. If any component ever needs drag/layout
    // animations, swap domAnimation for domMax instead.
    <LazyMotion features={domAnimation}>
      <Suspense fallback={<div>Loading...</div>}>
        <CookieConsentProvider>
          <div>
            {routes}
            <a

            
              href="https://wa.me/9360952142"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-icon"
              aria-label="Chat with us on WhatsApp"
            >
              <FaWhatsapp size={25} color="white" />
            </a>

            {/* Bottom banner shown on first visit (Accept All / Reject / Manage Preferences) */}
            <CookieBanner />

            {/* Popup modal matching the OneTrust-style preference center */}
            <CookiePreferencesModal />

            {/* Small floating button to reopen preferences anytime */}
            <CookieSettingsLink />

            {/* Loads Google Analytics only if performance cookies are allowed */}
            <AnalyticsLoader />

            <style>{`
              .whatsapp-icon {
                position: fixed;
                bottom: 20px;
                right: 20px;
                background-color: #25d366; /* WhatsApp green */
                border-radius: 50%;
                padding: 15px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
                transition: transform 0.3s ease;
              }

              .whatsapp-icon:hover {
                transform: scale(1.1);
              }

              .whatsapp-icon svg {
                transition: transform 0.3s ease;
              }

              @media (max-width: 480px) {
                .whatsapp-icon {
                  padding: 10px;
                  bottom: 15px;
                  right: 15px;
                }
              }
            `}</style>
          </div>
        </CookieConsentProvider>
      </Suspense>
    </LazyMotion>
  );
}

export default App;